import { getStoreConfig } from 'config'
import type { PriceRange } from '@pylot-data/pylotschema'
import type { Maybe, ProductImage } from '@pylot-data/pylotschema'
import NextHead from 'next/head'
import { product_prefix } from '@components/UrlConfiguration/UrlConfiguration'

export const CONFIGURABLE_PRODUCT = 'ConfigurableProduct'

export type Props = {
    product: ProductProps
    activeProductSKU: string
}

export type ProductCategory = {
    name: string
    url_path: string | null
    breadcrumbs?:
        | {
              category_id: null
              category_name: string
              category_url_path: string | null
              category_uid: string
              __typename: string
          }[]
        | undefined
        | null
}[]

export type ItemProps = {
    ProductName: string
    ProductID: number
    SKU: string
    Categories: ProductCategory
    ImageURL: Maybe<string> | undefined
    URL: string
    Brand: string
    Price: Maybe<number>
}

export type ProductProps = {
    name: string
    id: number
    sku: string
    categories: ProductCategory
    thumbnail: Maybe<ProductImage>
    url_key: string
    brand_text: string
    __typename: string
    variants: []
    price_range: PriceRange
}

export type variantProduct = {
    product?: ProductProps
}

export const KlaviyoViewedProductTracker = ({
    product,
    activeProductSKU
}: Props) => {
    const {
        name,
        id,
        sku,
        categories,
        thumbnail,
        brand_text,
        url_key,
        __typename,
        variants,
        price_range: {
            minimum_price: { final_price: { value = 0 } = {} } = {}
        } = {}
    } = product

    const config = getStoreConfig()
    const { base } = config
    const isConfig = __typename === CONFIGURABLE_PRODUCT

    const variantProduct: variantProduct = isConfig
        ? variants.find(
              (variant: { product: { sku: string } }) =>
                  variant.product.sku === activeProductSKU
          ) ?? {}
        : {}

    const productPrice =
        variantProduct?.product?.price_range?.minimum_price?.final_price
            ?.value ?? value
    const productSku = variantProduct?.product?.sku ?? sku
    const categoryList = categories?.map((category) => category.name)

    const item = {
        ProductName: name,
        ProductID: id,
        SKU: productSku,
        Categories: categoryList,
        ImageURL: thumbnail?.url,
        URL: `${base.url.baseUrl}${product_prefix}/${url_key}`,
        Brand: brand_text,
        Price: productPrice
    }

    const data = `
        (function () {
            var w = window;
            var item = ${JSON.stringify(item)};
            if (w.klaviyo && typeof w.klaviyo.track === 'function') {
                try { w.klaviyo.track('Viewed Product', item); } catch(e) {}
                return;
            }
            w._klOnsite = w._klOnsite || [];
            w._klOnsite.push(['track', 'Viewed Product', item]);
        })();`

    return (
        <NextHead>
            <script
                id="KlaviyoProductTrackerScript"
                type="application/javascript"
                dangerouslySetInnerHTML={{
                    __html: data
                }}
            />
        </NextHead>
    )
}
